import { isEmpty } from '@ember/utils';
import type { ValidationResult } from 'ember-changeset/types';

export default function validateListSelectionAddOption(args: {
  existingOptionVals: string[];
  addOptionsLabel: string;
}) {
  return {
    val: (
      _key: string,
      newValue: string,
      oldValue: string,
      _changes: any,
      _content: any,
    ): ValidationResult => {
      let val = newValue || oldValue;
      if (isEmpty(val)) {
        return 'Need to enter a value';
      }
      val = val.toLowerCase().trim();
      if (args.existingOptionVals.some((x) => x.toLowerCase() == val)) {
        return `That ${args.addOptionsLabel} already exists`;
      }
      return true;
    },
  };
}
